export default __webpack_public_path__ + "static/tokenizationOG-94b41e730b8766ebdc438d59e6404c26.jpg";